import { InputField, ToggleField } from 'components/molecules'
import { Form, Formik } from 'formik'
import { Button, Card, CardBody } from 'reactstrap'
import PropTypes from 'prop-types'
import { notificationTemplateSchema } from './notification-template-schema'
import initialValues from './template-form-initial-values'
import TinkerlustTemplateForm from 'domains/announcements/components/notification-template-form/tinkerlust-template-form'
import WhatsappTemplateForm from 'domains/announcements/components/notification-template-form/whatsapp-template-form'
import { useState } from 'react'

const propTypes = {
  selectedTemplate: PropTypes.shape({
    id          : PropTypes.number,
    name        : PropTypes.string,
    description : PropTypes.string,
    whatsapp    : PropTypes.array,
    tinkerlust  : PropTypes.object
  }),
  onSubmit: PropTypes.func
}

const defaultProps = {
  onSubmit         : () => {},
  selectedTemplate : undefined
}

const NotificationTemplateForm = ({
  selectedTemplate,
  onSubmit
}) => {

  const [ hasWhatsapp, setHasWhatsapp ] = useState(selectedTemplate?.whatsapp?.length > 0 || false)
  const submitButtonText                = selectedTemplate ? 'Update Notification Template' : 'Create Notification Template'


  return (
    <Formik
      initialValues={ initialValues(selectedTemplate, selectedTemplate?.tinkerlust, selectedTemplate?.whatsapp) }
      validationSchema={ notificationTemplateSchema(hasWhatsapp) }
      enableReinitialize={ true }
      onSubmit={ onSubmit }
    >
      {
        (formikBag) => (
          <Card>
            <CardBody>
              <Form>
                <InputField
                  type='text'
                  name='name'
                  label='Name'
                  required={ true }
                />
                <InputField
                  type='text'
                  name='description'
                  label='Description'
                  required={ true }
                />
                <TinkerlustTemplateForm />
                <ToggleField
                  id={ 'has_push_notif' }
                  name={ 'has_push_notif' }
                  label={ 'Has Push Notif?' }
                  formText={ <>
                    <strong>{ 'Yes: ' }</strong>{ 'Jika Memiliki Push Notif maka akan terkirim notif melalu mobile app bagi user yang sudah memilikinya' }
                    <br />
                    <strong>{ 'No: ' }</strong>{ 'Tidak akan mengirim push notif' }
                  </> }
                />
                <WhatsappTemplateForm
                  hasWhatsapp={ hasWhatsapp }
                  onChangeHasWhatsapp={ setHasWhatsapp }
                  formikBag={ formikBag }
                />

                <Button
                  type='submit'
                  color='primary'
                  disabled={ formikBag.isSubmitting }
                >
                  { submitButtonText }
                </Button>

              </Form>
            </CardBody>
          </Card>

        )
      }
    </Formik>
  )
}

NotificationTemplateForm.propTypes    = propTypes
NotificationTemplateForm.defaultProps = defaultProps

export default NotificationTemplateForm
